export const berechnungsgrundlageDreiMonatsschnitt = {
  moegliche_arbeitstage: 'moegliche_arbeitstage',
  anzahl_sv_tage: 'anzahl_sv_tage',
} as const;

export type BerechnungsgrundlageDreMonatsschnitt =
  keyof typeof berechnungsgrundlageDreiMonatsschnitt;
